module.exports = __webpack_public_path__ + "img/harvester.b14e570b.svg";